import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'antd';
import { Popup, TextArea } from '_atoms';
import { Typography } from '_atoms/Typography';
import './style.scss';

const FORM_NAME = 'form-cancel-promotion-request';

interface PopupCancelPromotionRequestProps {
  open: boolean;
  requestTitle: string;
  loading?: boolean;
  onClose: () => void;
  onSubmit: (values: { cancellation_comment: string }) => void;
}

export const PopupCancelPromotionRequest: React.FC<PopupCancelPromotionRequestProps> = ({
  open,
  requestTitle,
  loading,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const comment = Form.useWatch('cancellation_comment', form) as string | undefined;

  useEffect(() => {
    if (!open) form.resetFields();
  }, [open]);

  return (
    <Popup
      className="popup-cancel-promotion-request mobile-full-size"
      open={open}
      title={t('translation:promotion_request_details.title_cancel')}
      onClose={onClose}
      cancelButtonProps={{ onClick: onClose, children: t('translation:promotion_request_details.button_cancel') }}
      okButtonProps={{
        children: t('translation:promotion_request_details.button_cancel_request'),
        form: FORM_NAME,
        htmlType: 'submit',
        loading,
        disabled: !comment?.trim(),
      }}
    >
      <Typography.Text className="popup-cancel-promotion-request__text">
        {t('translation:promotion_request_details.text_cancel_prefix')} <strong>{requestTitle}</strong>{' '}
        {t('translation:promotion_request_details.text_cancel_suffix')}
      </Typography.Text>
      <Form name={FORM_NAME} form={form} validateTrigger="onSubmit" onFinish={onSubmit}>
        <TextArea
          label={t('translation:promotion_request_details.label_cancellation_reason')}
          placeholder={t('translation:promotion_request_details.ph_cancellation_reason')}
          maxLength={6000}
          required
          itemProps={{
            name: 'cancellation_comment',
            rules: [{ required: true, message: t('translation:validation.required') }],
          }}
        />
      </Form>
    </Popup>
  );
};
